import makeStyles from '@material-ui/core/styles/makeStyles'
import { discardItemAndReturnToReviewRequested } from '../../actions/createACard'
import { useDispatch, useSelector } from 'react-redux'

const useStyles = makeStyles((theme) => ({
    discardAndreviewAction: {
        textAlign: 'left',
        marginLeft: '12px',
        fontWeight: 'bold',
        color: theme.palette.secondary.main,
        cursor: 'pointer',
        '&:hover': {
            textDecoration: 'underline',
        },
        marginTop: '1em',
    },
}))

const DiscardItemAndReturnToReview = () => {
    const classes = useStyles()
    const dispatch = useDispatch()
    const { cards } = useSelector((state) => state.createACard)

    const handleDiscardAndReturnToReview = () => {
        dispatch(discardItemAndReturnToReviewRequested())
    }

    return (
        <>
            {cards.length > 0 && (
                <div
                    className={classes.discardAndreviewAction}
                    aria-label="discard and return to review"
                    onClick={handleDiscardAndReturnToReview}
                >
                    Discard and return to review
                </div>
            )}
        </>
    )
}

export default DiscardItemAndReturnToReview
